// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1owbk","toggle":"styles_toggle__1dcQL","preview":"styles_preview__2D5Nt"};